"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var logging_exports = {};
__export(logging_exports, {
  ConsoleFetchLogger: () => ConsoleFetchLogger,
  NoopFetchLogger: () => NoopFetchLogger
});
module.exports = __toCommonJS(logging_exports);
var import_io = require("@cartographerio/io");
class NoopFetchLogger {
  constructor() {
    this.logFetchRequest = (_url, _options) => import_io.IO.noop();
    // biome-ignore lint/suspicious/noConfusingVoidType:
    this.logFetchResponse = (_context, _response) => import_io.IO.noop();
    // biome-ignore lint/suspicious/noConfusingVoidType:
    this.logFetchError = (_context, _error) => import_io.IO.noop();
  }
}
const now = import_io.IO.wrap(() => /* @__PURE__ */ new Date());
class ConsoleFetchLogger {
  constructor(logBodies = false) {
    this.logFetchRequest = (url, options) => {
      if (this.logBodies) {
        console.log(">>", options.method, url, options.body);
      } else {
        console.log(">>", options.method, url);
      }
      return now.chain((startTime) => ({ url, options, startTime }));
    };
    this.logFetchResponse = (context, response) => {
      const { url, options, startTime } = context;
      return now.chain((endTime) => `${endTime.getTime() - startTime.getTime()}ms`).chain((duration) => {
        if (this.logBodies) {
          console.log("<<", options.method, url, duration, response.status);
        } else {
          console.log("<<", options.method, url, duration);
        }
        return import_io.IO.noop();
      });
    };
    this.logFetchError = (context, error) => {
      const { url, options, startTime } = context;
      return now.chain((endTime) => `${startTime.getTime() - endTime.getTime()}ms`).chain((duration) => {
        console.log("!!", options.method, url, duration, error);
        return import_io.IO.noop();
      });
    };
    this.logBodies = logBodies;
  }
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  ConsoleFetchLogger,
  NoopFetchLogger
});
//# sourceMappingURL=logging.js.map
